const baseServerUrl = {
  // base: "https://ysfwtestapi.yaobailian.com",
  // webScoketUrl: "wss://ysfwtestapi.yaobailian.com",
  base: "https://ysfwapi.yaobailian.com",
  webScoketUrl: "wss://ysfwapi.yaobailian.com",
  uploadUrl: "https://ysfwdbapi.yaobailian.com",
};

export default {
  identity: `${baseServerUrl.base}/Api`,
  webScoketUrl: `${baseServerUrl.webScoketUrl}/Echo`,
  uploadUrl: `${baseServerUrl.uploadUrl}/Api`,
};
